// ======================================================================
// 📁 File: src/modules/ppe/components/engineering/product-variant/ProductVariantKpiBar.jsx
// 📝 Purpose:
//   KPI Bar for Product Variant Master
//   - Total / Active / Inactive
//   - Drawing Required / Routing Required
//   - Used in Orders (future-safe)
// ======================================================================

import React, { useMemo } from "react";

const KpiCard = ({ title, value, color }) => (
  <div
    style={{
      flex: 1,
      minWidth: 160,
      background: "#fff",
      borderRadius: 12,
      padding: "14px 16px",
      boxShadow: "0 6px 14px rgba(0,0,0,0.08)",
      display: "flex",
      alignItems: "center",
      gap: 12,
      position: "relative",
    }}
  >
    {/* Vertical Accent */}
    <div
      style={{
        width: 4,
        height: "100%",
        background: color,
        borderRadius: 4,
      }}
    />

    <div>
      <div style={{ fontSize: 12, color: "#6b7280" }}>{title}</div>
      <div
        style={{
          fontSize: 22,
          fontWeight: 600,
          color: "#111827",
          lineHeight: 1.2,
        }}
      >
        {value}
      </div>
    </div>
  </div>
);

export default function ProductVariantKpiBar({ rows = [] }) {
  const kpis = useMemo(() => {
    const total = rows.length;
    const active = rows.filter((r) => r.is_active === 1).length;
    const inactive = rows.filter((r) => r.is_active === 0).length;
    const drawingRequired = rows.filter((r) => r.drawing_required).length;
    const routingRequired = rows.filter((r) => r.routing_required).length;
    const usedInOrders = rows.filter((r) => r.used_in_orders).length; // future-safe

    return {
      total,
      active,
      inactive,
      drawingRequired,
      routingRequired,
      usedInOrders,
    };
  }, [rows]);

  return (
    <div
      style={{
        display: "flex",
        gap: 16,
        marginBottom: 20,
        flexWrap: "wrap",
      }}
    >
      <KpiCard title="Total Variants" value={kpis.total} color="#6366f1" />
      <KpiCard title="Active" value={kpis.active} color="#16a34a" />
      <KpiCard title="Inactive" value={kpis.inactive} color="#9ca3af" />
      <KpiCard
        title="Drawing Required"
        value={kpis.drawingRequired}
        color="#0ea5e9"
      />
      <KpiCard
        title="Routing Required"
        value={kpis.routingRequired}
        color="#f59e0b"
      />
      <KpiCard
        title="Used in Orders"
        value={kpis.usedInOrders}
        color="#7c3aed"
      />
    </div>
  );
}
